import React, { useMemo } from 'react';
import cn from 'classnames';
import { relationshipModel } from "../../../models";
import { BillingGroupTypes, summarize } from "../genServicesSummary";
import { utils } from "../../../utils";
import { Badge, Callout, Tooltip, Typography } from 'seagull';
import { useResponsive } from "../../contexts";
import styles from "./BillingSchedule.module.scss";
const BillingSchedule = _ref => {
  let {
    selectedOptionalServices,
    selectedBundleID,
    relationship
  } = _ref;
  const {
    isMobile
  } = useResponsive();
  const effectiveDate = relationshipModel.effectiveDate(relationship);
  const services = useMemo(() => relationshipModel.actualServices(relationship, selectedBundleID), [relationship, selectedBundleID]);
  const billingSummary = useMemo(() => services.reduce(summarize({
    selectedOptionalServices: selectedOptionalServices || [],
    effectiveDate,
    now: new Date()
  }), {}), [services, selectedOptionalServices, effectiveDate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.sectionTitle, {
      [styles.mobile]: isMobile
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "bold"
  }, "Billing Schedule")), [BillingGroupTypes.Today, BillingGroupTypes.OnEffectiveDate, BillingGroupTypes.Once, BillingGroupTypes.Weekly, BillingGroupTypes.BiWeekly, BillingGroupTypes.Monthly, BillingGroupTypes.Quarterly, BillingGroupTypes.Yearly].flatMap(groupType => {
    return [false, true].map(variablePrice => {
      var _billingSummary$group;
      const group = (_billingSummary$group = billingSummary[groupType]) === null || _billingSummary$group === void 0 ? void 0 : _billingSummary$group.get(variablePrice);
      return group != null ? /*#__PURE__*/React.createElement("div", {
        key: "".concat(groupType, "-").concat(variablePrice),
        className: styles.billingSchedule
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "paragraph1",
        weight: "bold",
        showWhiteSpaces: true,
        breakWords: true,
        className: cn(styles.coverLetter, {
          [styles.mobile]: isMobile
        })
      }, "Billed ", groupType, groupType === BillingGroupTypes.OnEffectiveDate ? " (".concat(relationshipModel.formatEffectiveDate(relationship), ")") : '', ' ', "- ", !variablePrice ? utils.formatDollarAmount(group.totalAmount) : 'variable'), groupType === BillingGroupTypes.Today && group.hasBilledUpfront && /*#__PURE__*/React.createElement(Callout, {
        intent: "info",
        className: styles.billingScheduleListItem
      }, "First invoice contains recurring services in an active billing period."), group.services.map((_ref2, index) => {
        let {
          name,
          prorated,
          price,
          minPrice,
          isRange,
          unit
        } = _ref2;
        return /*#__PURE__*/React.createElement("ul", {
          key: index,
          className: cn(styles.listItem, styles.billingScheduleListItem),
          "data-testid": "billing-schedule-service"
        }, /*#__PURE__*/React.createElement(Typography, null, variablePrice && !isRange ? "".concat(name, " (").concat(utils.formatDollarAmount(price), "/").concat(unit || 'hour', ")") : isRange ? "".concat(name, " (").concat(minPrice != null ? "".concat(utils.formatDollarAmount(minPrice), " - ") : 'up to ').concat(utils.formatDollarAmount(price), ")") : name), prorated && (groupType === BillingGroupTypes.Today || !group.hasBilledUpfront) && /*#__PURE__*/React.createElement(Tooltip, {
          placement: "right",
          title: 'The final payment amount will be calculated based on the proposal approval date'
        }, /*#__PURE__*/React.createElement(Badge, {
          rounded: true,
          outlined: true,
          skin: "warning",
          className: styles.billingScheduleListItemBadge,
          "data-testid": "billing-schedule-service-prorated-badge"
        }, "Prorated")));
      })) : null;
    });
  }));
};
export default BillingSchedule;